module.exports = __webpack_public_path__ + "e257d129d847f090c5dc12f454575497.ttf";